<template>
  <main class="container">
    <slot name="nav" />

    <div class="bg">
      <div class="bg-body" :style="bgImage"></div>
    </div>
    
    <div class="layout">
      <div class="body">
        <slot />
      </div>
    </div>
  </main>
</template>

<style scoped lang="scss">
  .container {
    height: inherit;
  }

  .layout {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1260px;
    height: inherit;
    margin: 0 auto;
    padding: 20px;
  }

  .body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .bg {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
  }

  .bg-body {
    height: 200px;
    border-top-left-radius: 0 0;
    border-top-right-radius: 0 0;
    border-bottom-right-radius: 50% 80%;
    border-bottom-left-radius: 50% 80%;

    background-color: rgb(var(--blue-0));
    transform: scale(1.5) translateY(-35px);

    @include min-sm {
      height: 600px;
      max-width: 1600px;
      margin: 0 auto;

      background-size: cover;
      background-position: center top;
      background-repeat: no-repeat;

      transform: scale(1.5) translateY(-200px);
    }
  }
</style>

<script>
  export default {
    name: 'Quarter',

    props: {
      bg: {
        type: String,
        default: ''
      }
    },

    computed: {
      bgImage () {
        if (window.matchMedia('(min-width: 768px)').matches) return `background-image: linear-gradient(rgba(var(--blue-0), 0.85),rgba(var(--blue-0), 0.85)), url('${ this.bg }')`
      }
    }
  };
</script>